// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetCustomContentResponse

export type WidgetCustomContentApiResponse = {
	welcome: string | null;
	activity: string | null;
	activityTitle: string | null;
	offer: string | null;
	offerTitle: string | null;
	pax: string | null;
	hub: string | null;
	prices: string | null;
	products: string | null;
	customer: string | null;
	promoCodes: string | null;
	validation: string | null;
	pay: string | null;
	thankYou: string | null;
	myBooking: string | null;
	reconfirmBooking: string | null;
	giftcardSelect: string | null;
	packageSelect: string | null;
};

export type WidgetCustomContent = {
	welcome: string | null;
	activity: string | null;
	activityTitle: string | null;
	offer: string | null;
	offerTitle: string | null;
	pax: string | null;
	hub: string | null;
	prices: string | null;
	products: string | null;
	customer: string | null;
	promoCodes: string | null;
	validation: string | null;
	pay: string | null;
	thankYou: string | null;
	myBooking: string | null;
	reconfirmBooking: string | null;
	giftcardSelect: string | null;
	packageSelect: string | null;
};

export function hydrateWidgetCustomContent(data: WidgetCustomContentApiResponse): WidgetCustomContent {
	return { ...data };
}